module.exports = __webpack_public_path__ + "img/500-error.3d341389.png";